import {
  HUD_POSITION_TOP,
  HUD_POSITION_TOP_RIGHT,
  HUD_POSITION_RIGHT,
  HUD_POSITION_BOTTOM_RIGHT,
  HUD_POSITION_BOTTOM,
  HUD_POSITION_BOTTOM_LEFT,
  HUD_POSITION_LEFT,
  HUD_POSITION_TOP_LEFT,
  HUD_POSITION_CENTER,
} from './HudConstants';

export default class HudButtonGroup extends Phaser.Group {
  constructor(game, screenAnchor) {
    super(game);
    this.screenAnchor = screenAnchor;
    this.buttonPadding = 20;
    this.buttons = [];
    this.buttonWidth = 0;
    this.buttonHeight = 0;
  }

  // add a button to the group
  // note : you should call alignButtons and updatePosition after adding buttons
  // I figured a manual call was better in case of adding lots of buttons :)
  addButton(button) {
    this.buttons.push(button);
    this.add(button);
  }

  // aligns the buttons in a row in the group
  alignButtons() {
    // track the button group width / height
    this.buttonWidth = 0;
    this.buttonHeight = 0;
    // set flag, we need a second loop to align height.. so only bother if needed
    let alignHeight = false;
    // loop through buttons and align along the x axis
    this.buttons.forEach((btn) => {
      // position button based on current width
      btn.x = this.buttonWidth;
      // update the buttons width
      this.buttonWidth += btn.width + this.buttonPadding;

      // set button height and calculate if wee need to align height
      alignHeight = this.buttonHeight > 0 && btn.height != this.buttonHeight;
      this.buttonHeight = Math.max(this.buttonHeight, btn.height);
    });
    if (this.screenAnchor === HUD_POSITION_CENTER) {
      console.log(this.buttonWidth, this.buttons.length);
    }

    // align height :)
    if (alignHeight) {
      this.buttons.forEach((btn) => {
        btn.y = this.buttonHeight * 0.5 - btn.height * 0.5;
      });
    }
  }

  updatePosition() {
    // align buttons should be ca;lled before this
    // but if width/height = 0 assume call got missed
    if (this.buttonWidth + this.buttonHeight === 0) {
      this.alignButtons();
    }

    // figure out where this group should be in each extermity
    const posLeft = this.game.screenPaddingX;
    const posTop = this.game.screenPadding;
    const posRight = this.game.width - this.buttonWidth - this.game.screenPaddingX;
    const posBottom = this.game.height - this.buttonHeight - this.game.screenPadding;
    const posCenterX = this.game.width * 0.5 - this.buttonWidth * 0.5;
    const posCenterY = this.game.height * 0.5 - this.buttonHeight * 0.5;

    // position based on 'position' :)
    switch (this.screenAnchor) {
      case HUD_POSITION_TOP:
        this.y = posTop;
        this.x = posCenterX;
        break;
      case HUD_POSITION_TOP_RIGHT:
        this.y = posTop;
        this.x = posRight;
        break;
      case HUD_POSITION_RIGHT:
        this.y = posCenterY;
        this.x = posRight;
        break;
      case HUD_POSITION_BOTTOM_RIGHT:
        this.y = posBottom;
        this.x = posRight;
        break;
      case HUD_POSITION_BOTTOM:
        this.y = posBottom;
        this.x = posCenterX;
        break;
      case HUD_POSITION_BOTTOM_LEFT:
        this.y = posBottom;
        this.x = posLeft;
        break;
      case HUD_POSITION_LEFT:
        this.y = posCenterY;
        this.x = posLeft;
        break;
      case HUD_POSITION_TOP_LEFT:
        this.y = posTop;
        this.x = posLeft;
        break;
      case HUD_POSITION_CENTER:
        this.y = posCenterY;
        this.x = posCenterX;
        break;
    }
  }

  destroy() {
    this.screenAnchor = null;
    this.buttons = null;
    this.buttonWidth = null;
    this.buttonHeight = null;
    this.buttonPadding = null;

    super.destroy();
  }
}



// WEBPACK FOOTER //
// ./js/app/ui/hud/HudButtonGroup.js